import http from '@root/utils/axios/admin';

let state = {
    OrdersList: [],
    Order: {
        data: {},
        error: {}
    },
    OrderJourney: [],
    OrderUsers: []
}

let actions = {

    fetchOrdersList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/orders', { params: filter }).then((response) => {
                commit('setOrders', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchOrderJourneyList({ commit }, id) {

        return new Promise((resolve, reject) => {
            http.get('/api/orders/' + id + '/journey').then((response) => {
                commit('setOrderJourney', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchOrderUsersList({ commit }, id) {

        return new Promise((resolve, reject) => {
            http.get('/api/orders/' + id + '/users').then((response) => {
                commit('setOrderUsers', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    deleteOrder({ commit }, id) {
        return http.delete('/api/orders/' + id);
    },

    fetchOrder({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/orders/' + id).then((response) => {
                commit('setOrder', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateOrder({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/orders', data).then((response) => {
                commit('setOrder', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setOrderError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateExtraInfo({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/orders/' + data.id + '/extra-info', data).then((response) => {
                commit('setOrder', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setOrderError', error.response.data);
                }
                reject(error.response);
            })
        });
    },

    reviewOrder({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/orders/' + data.id + '/review', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        });
    },
    auditOrder({ commit }, data) {
        return new Promise((resolve, reject) => {

            http.post('/api/orders/' + data.get('id') + '/audit', data).then((response) => {

                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setOrderError', error.response.data);
                }
                reject(error.response);
            })
        });
    },




    assignOrder({ commit }, data) {

        return new Promise((resolve, reject) => {

            http.post('/api/orders/' + data.get('id') + '/assign', data).then((response) => {

                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setOrderError', error.response.data);
                }
                reject(error.response);
            })
        });
    },
    clientAccount({ commit }, data) {

        return new Promise((resolve, reject) => {

            http.post('/api/orders/' + data.get('id') + '/client-account', data).then((response) => {

                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setOrderError', error.response.data);
                }
                reject(error.response);
            })
        });
    },
    orderShipNumbers({ commit }, data) {

        return new Promise((resolve, reject) => {

            http.post('/api/orders/' + data.get('id') + '/order-ship-numbers', data).then((response) => {

                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setOrderError', error.response.data);
                }
                reject(error.response);
            })
        });
    },
    updateOrderStatus({ commit }, data) {

        return new Promise((resolve, reject) => {

            http.post('/api/orders/' + data.get('id') + '/update-status', data).then((response) => {

                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setOrderError', error.response.data);
                }
                reject(error.response);
            })
        });
    },
    completeQuickOrder({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/orders/' + data.get('id') + '/complete-quick-order', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setOrderError', error.response.data);
                }
                reject(error.response);
            })
        });
    },

}


let mutations = {
    setOrders(state, data) {
        state.OrdersList = data;
    },
    setOrderJourney(state, data) {
        state.OrderJourney = data;
    },
    setOrderUsers(state, data) {
        state.OrderUsers = data;
    },
    setOrder(state, data) {
        state.Order.data = data;
    },
    setOrderError(state, error) {

        state.Order.error = error.errors;
    },
    cleanOrderError(state, error) {
        state.Order.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}